import React from "react";
import {Link} from "react-router-dom";
import {ListItem} from "@deere/ux.uxframe-react";
import {Box, Grid, Typography, Tooltip} from '@deere/fuel-react';
import {toCapitalize} from "../shared/utils";

export const Criteria = (props) => {
    const criteria = props.criteria;
    const isCriteriaAdmin = props.isCriteriaAdmin;
    const isEdit = isCriteriaAdmin && criteria.status === "ACTIVE";
    const status = toCapitalize(criteria.status)

    let path = isEdit ? `/criteria-catalog/edit-criteria/${criteria.id}` : `/criteria-catalog/view-criteria/${criteria.id}`
    return (
        <ListItem className="list-group-item mb-1" style={{borderRadius: "0.25rem"}} key={criteria.id}>
            <Grid container>
                <Grid item xs={11} style={{width: 200, whiteSpace: 'nowrap'}}>
                    <Box
                        textOverflow="ellipsis"
                        overflow="hidden"
                    >
                        <Link
                            to={{
                                pathname: path
                            }}
                        >
                            {criteria.criteria.length > 100 ?
                                (
                                    <Tooltip
                                        title={criteria.criteria}
                                        placement="bottom-start"
                                    >
                                        <span>{criteria.criteria}</span>
                                    </Tooltip>
                                ) :
                                <span>{criteria.criteria}</span>
                            }
                        </Link>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="regular" component="p">
                            {status}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography size="md" fontWeight="bold" component="p" display="inline">
                        Category & Sub-Category {" "}
                    </Typography>
                    <Typography size="md" fontWeight="regular" component="p" display="inline">
                        {criteria.category.description}
                        {!!(criteria.subCategory) && criteria.subCategory.id && (
                            <span> - {criteria.subCategory.description} </span>
                        )}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
}
